import { clearAuth } from './auth';

let isRedirectingToLogin = false;

const redirectToLogin = () => {
	if (isRedirectingToLogin) {
		return;
	}
	isRedirectingToLogin = true;
	clearAuth();
	window.location.href = '/login';
};

export const ErrorHandler = (error) => {
	const response = error?.response;
	const request = error?.request;
	const code = error?.code;

	if (response) {
		if (response.status === 401 || response.status === 403) {
			redirectToLogin();
			return {
				status: false,
				context: { message: response?.data, status: response?.status },
			};
		}

		return {
			status: false,
			context: { message: response?.data, status: response?.status },
		};
	}

	if (request) {
		if (code === 'ERR_NETWORK') {
			return {
				status: false,
				context: {
					message: 'Unable to reach the server. Check your connection.',
					status: 503,
				},
			};
		}

		return {
			status: false,
			context: {
				message: 'Server timed out. Please try again.',
				status: 503,
			},
		};
	}

	return {
		status: false,
		context: {
			message: 'Something went wrong. Please try again.',
			status: 500,
		},
	};
};
